<!-- Projected toolbar (feed-results / story-posts / related-posts sort) -->
<ng-content select="[postListToolbar]"></ng-content>
<!-- Advanced-search builder (feed only); independent of the toolbar above -->
<ng-container *ngIf="showAdvancedSearch">
  <div class="advanced-search-component">
    <app-advanced-search
      [feed]="feed"
      [searchQuery]="feedSearchQuery"
    ></app-advanced-search>
  </div>
</ng-container>
<app-post-cards-tools
  *ngIf="showPagination"
  [viewMode]="viewMode"
  [toolsClass]="'footer'"
  [loading]="loading"
  [externalCurrentPage]="currentPage"
  [externalItemsPerPage]="itemsPerPage"
  [externalTotalItemsCount]="totalItemsCount"
  (externalPageChange)="onPageChanged($event)"
  (externalItemsPerPageChange)="onItemsPerPageChanged($event)"
></app-post-cards-tools>
<ng-container>
  <div class="app-loading-wrapper" *ngIf="!loading && postsListCount === 0">
    <div class="no-posts-message">
      {{ "feed.title.no-available-posts" | translate }}
    </div>
  </div>
  <div
    class="card-container posts"
    *ngIf="viewMode === 'default' || viewMode === 'threads'"
    #cardContainer
  >
    <app-loading-card
      type="post"
      [count]="feed?.count_posts ? feed.count_posts : 6"
      [animationEnabled]="true"
      *ngIf="loading"
    ></app-loading-card>
    <ng-container
      *ngFor="let post of posts; trackBy: postTrackByFn; let i = index"
    >
      <!-- In default mode: hide parent/context posts. In threads mode: show all. -->
      <app-post-card
        #postCardCmp
        *ngIf="
          !post.is_collapsed && (viewMode === 'threads' || !post.is_parent)
        "
        [post]="post"
        [user]="user"
        [viewMode]="'default'"
        [showThreads]="viewMode === 'threads'"
        [allowRelatedPosts]="true"
        [feed]="feed"
        [viewConfig]="viewConfig"
        [feedId]="feed?.id"
        [highlighted]="postScrollMode && currentPostIndex === i"
        [attr.id]="'post-' + i"
        [attr.data-post-id]="post.id"
        (togglePostDetails)="onTogglePostDetails($event, i)"
        [class.active-post]="
          post.id == selectedPostId && feed?.views?.includes('details')
        "
        [currentLanguage]="currentLanguage"
        [timeShown]="timeShown"
        [loadingAlgorithmPostIds]="loadingAlgorithmPostIds"
        [appliedAlgorithmPostIds]="appliedAlgorithmPostIds"
        [disableTools]="disableTools"
        [isStoryMode]="isStoryMode"
        [selectable]="selectable"
        [customTogglePostSelect]="customTogglePostSelect ? customTogglePostSelect(post) : null"
        [customRemovePost]="customRemovePost"
        (requestToggleThread)="onRequestToggleThread($event)"
      ></app-post-card>
    </ng-container>
  </div>

  <div
    #masonryContainer
    class="card-container posts-gallery"
    *ngIf="viewMode === 'gallery'"
  >
    <app-loading-card
      type="post-gallery"
      [count]="feed?.count_posts ? feed.count_posts : 6"
      *ngIf="loading"
    ></app-loading-card>

    <div
      #masonryItems
      [ngClass]="{ details: postDetailsList[post.id] }"
      *ngFor="let post of posts; trackBy: postTrackByFn; let i = index"
    >
      <app-post-card
        [post]="post"
        [user]="user"
        [viewConfig]="viewConfig"
        (imageLoaded)="onImageLoaded()"
        (togglePostDetails)="onTogglePostDetails($event, i)"
        [viewMode]="'gallery'"
        [feedId]="feed?.id"
        [class.active-post]="
          post.id == selectedPostId && feed?.views?.includes('details')
        "
        [currentLanguage]="currentLanguage"
        [timeShown]="timeShown"
        [loadingAlgorithmPostIds]="loadingAlgorithmPostIds"
        [appliedAlgorithmPostIds]="appliedAlgorithmPostIds"
        [disableTools]="disableTools"
        [selectable]="selectable"
        [customTogglePostSelect]="customTogglePostSelect ? customTogglePostSelect(post) : null"
        [customRemovePost]="customRemovePost"
      ></app-post-card>
    </div>
  </div>
</ng-container>
